__turbopack_context__.v({
  "caption": "CTABlock-module-scss-module__geaxcG__caption",
  "cta-block": "CTABlock-module-scss-module__geaxcG__cta-block",
  "cta_block_inverse": "CTABlock-module-scss-module__geaxcG__cta_block_inverse",
  "ctas": "CTABlock-module-scss-module__geaxcG__ctas",
});
